import React from 'react';
import * as FiIcons from 'react-icons/fi';
import AnimatedSection from '../../components/ui/AnimatedSection';
import SectionHeading from '../../components/ui/SectionHeading';
import SafeIcon from '../../common/SafeIcon';

const GeoExplanation = () => {
  const { FiCpu, FiDatabase, FiMessageSquare } = FiIcons;

  const features = [
    {
      icon: FiCpu,
      title: "AI Model Ranking",
      desc: "We optimize your digital footprint so Large Language Models (LLMs) like ChatGPT, Claude, and Gemini reference your NYC business as the top recommended entity."
    },
    {
      icon: FiDatabase,
      title: "Semantic Authority",
      desc: "Through advanced schema markup, structured data, and entity building, we help AI engines perfectly understand your relevance to Manhattan, Brooklyn, and local markets."
    },
    {
      icon: FiMessageSquare,
      title: "Conversational Search",
      desc: "Users don't just search keywords anymore; they ask complex questions. We optimize your content to capture long-tail conversational queries driving high-intent local traffic."
    }
  ];

  return (
    <section className="py-24 bg-slate-950 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimatedSection>
          <SectionHeading 
            subtitle="The Future of Search" 
            title="Generative Engine Optimization (GEO)" 
            description="Traditional SEO is no longer enough. Businesses in New York City are now discovered through AI conversational models. We ensure you rank as the authoritative entity in AI answers."
          />
        </AnimatedSection>

        <div className="grid md:grid-cols-3 gap-8 mt-16">
          {features.map((feature, i) => (
            <AnimatedSection key={i} delay={i * 0.2}>
              <div className="glass-panel p-8 rounded-2xl h-full border border-slate-800 hover:border-blue-500/50 transition-colors group">
                <div className="w-14 h-14 rounded-lg bg-blue-900/30 flex items-center justify-center mb-6 text-blue-500 group-hover:scale-110 transition-transform">
                  <SafeIcon icon={feature.icon} className="text-3xl" />
                </div>
                <h3 className="text-xl font-bold text-white mb-4">{feature.title}</h3>
                <p className="text-slate-400 leading-relaxed">{feature.desc}</p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GeoExplanation;